export const TEXT_MIXIN_BY_INDICATOR_COUNTER_SIZE = {
    "16": "caption-s-accent",
    "20": "caption-m-accent",
    "24": "title-s",
} as const;
